import React from 'react';
import { Container } from 'semantic-ui-react';
import SliderContent from './SliderContent';

const SliderPlaceholderImage = (props) => {
  const {
    image,
    retinaImage,
    mobileImage,
    mobileRetinaImage,
    title,
    introContent,
    cta,
  } = props;
  return (
    <div className="category-hero-banner__placeholder-wrapper">
      <div className="category-hero-banner__placeholder-img-wrapper">
        <img
          className="category-hero-banner__placeholder-img"
          src={image}
          srcSet={`${image} ${
            retinaImage != '' ? ',' + retinaImage + '2x' : ''
          }`}
          alt="hero banner for category page"
        />
        <img
          className="category-hero-banner__placeholder-img category-hero-banner__placeholder-img-mobile"
          src={mobileImage}
          srcSet={`${mobileImage} ${
            mobileRetinaImage != '' ? ',' + mobileRetinaImage + '2x' : ''
          }`}
          alt="mobile hero banner for category page"
        />
        <div className="category-hero-banner__overlay"></div>
      </div>
      <Container>
        <SliderContent title={title} introContent={introContent} cta={cta} />
      </Container>
    </div>
  );
};

export default SliderPlaceholderImage;
